import gql from 'graphql-tag'
import { get } from 'lodash'
import { apolloClientPrivate } from '../graphql/apolloClient'

export interface IVariables {
  name: string
}

export interface IResponse {
  admin: {
    createGroup: {
      id: number
      name: string
    }
  }
}

export const CREATE_GROUP_MUTATION = gql`
  mutation createGroup($name: String!) {
    admin {
      createGroup(data: { name: $name }) {
        id
        name
      }
    }
  }
`
// TODO move into a gql file and use the generated query
export async function createGroupMutation(variables: IVariables): Promise<{
  id: number
  name: string
}> {
  const result = await apolloClientPrivate.mutate<IResponse>({
    variables,
    mutation: CREATE_GROUP_MUTATION,
    fetchPolicy: 'no-cache'
  })

  return get(result, 'data.admin.createGroup')
}
